import { Link } from 'react-router-dom';
import '../css/postLayout.css';
import '../css/rightSidebar.css';

const RightSidebar = ({ title, relatedPosts }) => {
  const getTopicSlug = (post) => {
    const { topics } = post;
    return topics[0].slug;
  };
  return (
    <div id="right-sidebar" className="fix-sidebar mb-3">
      <div className="card related-posts">
        <div className="card-header"> Bài viết liên quan </div>
        <ul className="card-body m-0">
          {relatedPosts.map((post, index) => (
            <li key={post.id} className="card-item mb-3">
              <Link
                to={`/${getTopicSlug(post)}/${post.slug}`}
                title={post.title}
                className="a d-block w-100 image"
              >
                <img
                  src={post.thumbnail}
                  alt={post.title}
                  className="w-100 "
                  loading="lazy"
                />
              </Link>
              <Link
                to={`/${getTopicSlug(post)}/${post.slug}`}
                title={title}
                className="a title-related-post"
              >
                {post.title}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default RightSidebar;
